import { render, staticRenderFns } from "./IngredientShowData.vue?vue&type=template&id=424bd50e"
import script from "./IngredientShowData.vue?vue&type=script&lang=js"
export * from "./IngredientShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports